export default __webpack_public_path__ + "static/media/ideas_5.3743b36f.png";